// extracted by mini-css-extract-plugin
module.exports = {"container":"content-module--container--17n3r","footer":"content-module--footer--6LaZE content-module--container--17n3r"};